import './video-reviews.component.scss'

import Swiper from 'swiper';
import { Navigation } from 'swiper/modules';

import 'swiper/css'
import 'swiper/css/navigation'

class VideoReviews {
	constructor(elements, settings) {
		this.elements = elements
		this.settings = settings

		this.init()
	}

	defineSlider() {
		this.slider = new Swiper(this.elements.slider, {
			modules: [Navigation],
			slidesPerView: 1,
			spaceBetween: 20,
			navigation: this.elements.navigation,
			allowTouchMove: true,
			// autoHeight: true,
			breakpoints: {
				667: {
					slidesPerView: 2
				},
				1024: {
					slidesPerView: 3
				},
			}
		})
	}

	init() {
		this.defineSlider()
	}
}

const reviewsList = document.querySelectorAll('.video-reviews__list-wrap')

reviewsList.forEach(item => {
	const slider = item.querySelector('.video-reviews__list')
	new VideoReviews({
		slider: slider,
		navigation: {
			prevEl: item.querySelector('.swiper-button-prev'),
			nextEl: item.querySelector('.swiper-button-next'),
		}
	})
})
